<template>
  <section class="lineups-table-container">
    <div
      class="lineups-table"
      v-for="(client, indexClient) in assortedLineups"
      :key="buildIndex('client', indexClient)"
    >
      <p class="client-title">{{ client.clientName }}</p>
      <div
        class="lineup-container"
        v-for="(lineup, indexLineup) in client.lineups"
        :key="buildIndex('lineup', indexLineup)"
      >
        <p class="lineup-title">{{ lineup.lineupName }}</p>
        <div
          class="errors-container"
          v-for="(error, indexError) in lineup.errors"
          :key="buildIndex('error', indexError)"
        >
          <p class="error-type-title">{{ errorLabel(error.type) }}</p>
          <table class="errors-table lineup-error mds-data-table" v-if="error.type === 'lineup'">
            <thead class="mds-data-table__header">
              <tr class="mds-data-table__row">
                <td class="mds-data-table__header-cell" width="30%">Program</td>
                <td class="mds-data-table__header-cell" width="20%">Menu</td>
                <td class="mds-data-table__header-cell" width="50%">Description</td>
              </tr>
            </thead>
            <tbody class="mds-data-table__body">
              <tr
                class="mds-data-table__row"
                v-for="(fund, indexFund) in error.funds"
                :key="buildIndex('fund', indexFund)"
              >
                <td class="mds-data-table__cell">{{ fund.rowIdentifier.program || "---" }}</td>
                <td class="mds-data-table__cell">{{ fund.rowIdentifier.menu || "---" }}</td>
                <td class="mds-data-table__cell">{{ fund.message || "---" }}</td>
              </tr>
            </tbody>
          </table>
          <table class="errors-table fund-error" v-if="error.type === 'fund'">
            <thead class="mds-data-table__header">
              <tr class="mds-data-table__row">
                <td class="mds-data-table__header-cell" width="30%">Fund</td>
                <td class="mds-data-table__header-cell" width="10%">Ticker</td>
                <td class="mds-data-table__header-cell" width="10%">SecID</td>
                <td class="mds-data-table__header-cell" width="50%">Description</td>
              </tr>
            </thead>
            <tbody class="mds-data-table__body">
              <tr
                class="mds-data-table__row"
                v-for="(fund, indexFund) in error.funds"
                :key="buildIndex('fund', indexFund)"
              >
                <td class="mds-data-table__cell" width="30%">
                  {{ fund.rowIdentifier.fundName || "---" }}
                </td>
                <td class="mds-data-table__cell" width="10%">
                  {{ fund.rowIdentifier.ticker || "---" }}
                </td>
                <td class="mds-data-table__cell" width="10%">{{ fund.secId || "---" }}</td>
                <td class="mds-data-table__cell" width="50%">{{ fund.message || "---" }}</td>
              </tr>
            </tbody>
          </table>
          <table class="errors-table fund-error" v-if="error.type === 'warning'">
            <thead class="mds-data-table__header">
              <tr class="mds-data-table__row">
                <td class="mds-data-table__header-cell" width="30%">Fund</td>
                <td class="mds-data-table__header-cell" width="20%">Ticker</td>
                <td class="mds-data-table__header-cell" width="50%">Description</td>
              </tr>
            </thead>
            <tbody class="mds-data-table__body">
              <tr
                class="mds-data-table__row"
                v-for="(fund, indexFund) in error.funds"
                :key="buildIndex('fund', indexFund)"
              >
                <td class="mds-data-table__cell" width="30%">
                  {{ fund.rowIdentifier.fundName || "---" }}
                </td>
                <td class="mds-data-table__cell" width="20%">
                  {{ fund.rowIdentifier.ticker || "---" }}
                </td>
                <td class="mds-data-table__cell" width="50%">{{ fund.message || "---" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { chain, includes, uniqBy } from 'lodash';

export default {
  name: 'lineupsTable',
  props: ['lineups', 'type'],
  data() {
    return {
      errorTypes: {
        fundLevel: ['FundStatusRemovedOrNone', 'SecIdUnknown', 'ClientFundNotInProduct'],
        lineupLevel: [
          'UnknownLineupIdentifier',
          'InvalidProgramTypeForProduct',
          'MissingLineupIdentifier',
          'InvalidatedFundByOtherFundInTheLineup',
        ],
      },
    };
  },
  methods: {
    buildIndex(prefix, index) {
      return `${prefix}-${index}`;
    },
    errorLabel(type) {
      if (type === 'fund') {
        return 'Fund Errors';
      }
      if (type === 'lineup') {
        return 'Lineup Errors';
      }
      if (type === 'warning') {
        return '';
      }
      return '';
    },
    errorType(error) {
      if (includes(this.errorTypes.lineupLevel, error)) {
        return 'lineup';
      }
      if (includes(this.errorTypes.fundLevel, error)) {
        return 'fund';
      }
      return 'warning';
    },
  },
  computed: {
    assortedLineups() {
      const that = this;
      const flatLineups = [];
      this.lineups.forEach((lineup) => {
        lineup.errors.forEach((error, i) => {
          const formattedLineup = {
            lineupName:
              lineup.rowIdentifier
              && `${lineup.rowIdentifier.product} ${lineup.rowIdentifier.program} ${lineup.rowIdentifier.menu}`,
            type: that.errorType(error),
            rowIdentifier: lineup.rowIdentifier,
            message: lineup.messages[i],
            error,
          };
          flatLineups.push(formattedLineup);
        });
      });
      const lineups = chain(flatLineups)
        .groupBy('rowIdentifier.client.clientName')
        .map((v, i) => ({
          clientName: i,
          lineups: chain(v)
            .groupBy('lineupName')
            .map((vp, ip) => ({
              lineupName: ip,
              errors: chain(vp)
                .groupBy('type')
                .map((vl, il) => ({
                  type: il,
                  funds: uniqBy(vl, (fund) => {
                    if (il === 'lineup') {
                      return `${fund.lineupName} ${fund.message}`;
                    }
                    return fund.rowIdentifier && `${fund.rowIdentifier.fundName} ${fund.message}`;
                  }),
                }))
                .value(),
            }))
            .value(),
        }))
        .value();
      return lineups;
    },
    tableType() {
      return `${this.type}-lineups-table`;
    },
    nameHeader() {
      if (this.type === 'invalid') {
        return 'Client/Lineup/Funds';
      }
      return 'Funds';
    },
  },
};
</script>
<style lang="scss" scoped>
.lineups-table-container {
  padding: 0 0 20px 0;
}

.lineups-table {
  height: 100%;
  max-height: 400px;
  overflow: auto;

  .client-title {
    @include mds-level-4-heading();
  }
  .lineup-container {
    margin: $mds-space-inset-4-x 0;
  }
  .lineup-title {
    @include mds-level-6-heading();
  }
  .errors-container {
    padding: $mds-space-inset-2-x;
    background-color: $mds-color-neutral-95;
  }
  .error-type-title {
    @include mds-body-text-m();
    font-weight: $mds-font-weight-bold;
    margin-top: 0;
  }
  .errors-table {
    width: 100%;
    tbody {
      tr {
        border-top: 2px solid $mds-color-neutral-80;
        &:first-child {
          border: none;
        }
        td {
          padding: $mds-space-inset-2-x $mds-space-inset-1-x;
          &:first-child {
            padding-left: 0;
          }
        }
      }
    }
    thead {
      td {
        font-weight: $mds-font-weight-bold;
      }
    }
  }
}

.lineups-table {
  @include horizontal-scroll-gradient;
}
</style>
